var map = {
	"./0.svg": "I7cr",
	"./11111.svg": "Jtm8",
	"./137.svg": "aMB1",
	"./138.svg": "uvCL",
	"./18.svg": "O++u",
	"./2.svg": "JJiM",
	"./21.svg": "+j7j",
	"./22.svg": "1XQs",
	"./23.svg": "ZKFy",
	"./26.svg": "WKoa",
	"./30.svg": "WxFn",
	"./31.svg": "13Yp",
	"./32.svg": "ow3c",
	"./34.svg": "umMh",
	"./40.svg": "WDjG",
	"./9.svg": "7KfI",
	"./down.svg": "zE7U",
	"./omit.svg": "u8Bn",
	"./player.svg": "f9C8",
	"./statistics.svg": "Dyr+",
	"./status.svg": "MxtL",
	"./up.svg": "bJYr"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8QYh";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/details/event ^\.\/.*\.svg$
// module id = 8QYh
// module chunks = 0